import {
	computed,
	ref,
	Ref,
	SetupContext,
} from '@vue/composition-api';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';

export interface RadioButtonConfig <T extends string>{
	choiceKeys: Ref<T[]>;
	initialChoice: T;
	labels: Record<T, string>;
}

export interface UseRadioButtons<T extends string> {
	choices: Ref<SelectBoxChoice[]>;
	selectedChoice: Ref<T>;
	select(v: T): void;
}

export const useRadioButtons = <T extends string>(
	ctx: SetupContext,
	config: RadioButtonConfig<T>,
): UseRadioButtons<T> => {
	// Weird TS inference issue here, have to us "as" :(
	const selectedChoice = ref(config.initialChoice) as Ref<T>;
	const choices: Ref<SelectBoxChoice[]> = computed(() => config
		.choiceKeys
		.value
		.map((key) => ({
			key,
			label: ctx.root.$t(config.labels[key]) as string,
		})));
	const select = (newVal: T) => {
		selectedChoice.value = newVal;
	};
	return {
		choices,
		selectedChoice,
		select,
	};
};
